import { useNavigate } from "react-router-dom";
import { ProjectIntakeForm } from "../components/ProjectIntakeForm";
import { useProjectStore } from "../stores/projectStore";
import { Project } from "@/lib/api";

const ProjectIntakePage = () => {
  const navigate = useNavigate();
  const setProject = useProjectStore((state) => state.setProject);

  const handleProjectCreated = (projectData: Project) => {
    setProject(projectData);
    // Save to localStorage for persistence across sessions
    const savedProjects = JSON.parse(localStorage.getItem('creator-projects') || '[]');
    const updatedProjects = [...savedProjects, projectData];
    localStorage.setItem('creator-projects', JSON.stringify(updatedProjects));
    
    const projectId = projectData._id || (projectData as any).id;
    
    if (projectId) {
      // Explicit check for review status
      // Only go to results if explicitly reviewed. Default (false/undefined) goes to pending.
      if (projectData.is_reviewed === true) {
        navigate(`/projects/${projectId}`);
      } else {
        navigate(`/projects/${projectId}/pending`);
      }
    } else {
      console.error("Project created but ID missing:", projectData);
    }
  };

  const handleBack = () => {
    navigate('/projects/new');
  };

  return (
    <div className="bg-cream-yellow min-h-screen pt-16">
      <ProjectIntakeForm
        onProjectCreated={handleProjectCreated}
        onBack={handleBack}
      />
    </div>
  );
};

export default ProjectIntakePage;